import { makeStyles } from '@mui/styles'
import classNames from 'classnames'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeExternalLinks from 'rehype-external-links'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

type MarkdownProps = {
  extraClasses?: {
    text: string
  }
  isSingleLine?: boolean
} & React.ComponentProps<typeof ReactMarkdown>

const useStyles = makeStyles({
  root: {
    color: 'inherit',
    '& p, & h1, & h2': {
      margin: 0,
    },
    '& ul, & ol': {
      margin: 0,
    },
    '& a': {
      color: 'inherit',
    },
  },
})

const Markdown = ({ extraClasses, ...props }: MarkdownProps): JSX.Element => {
  const classes = useStyles()

  return (
    <ReactMarkdown
      {...props}
      remarkPlugins={[remarkGfm, remarkBreaks]}
      className={classNames(classes.root, extraClasses?.text)}
      rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
    />
  )
}

export default Markdown
